/**
 * Accès au guide d'utilisation de la reprise LAP : vendeur dont la boutique est reliée à son ERP,
 * c'est-à-dire qui voit au moins un écran LAP (« Laboratoires, marques et planning » ou
 * « Outre-mer »). Mêmes drapeaux du profil que les entrées de menu de ces écrans, calculés par le
 * serveur. Une seule règle pour le menu, la page et le lien de la notice du mode ombre.
 */
export const canSeeErpGuide = (dataMyProfile?: any): boolean =>
  !!dataMyProfile?.selectCompanyDefault?.erpCatalogManaged ||
  !!dataMyProfile?.selectCompanyDefault?.erpOverseasOperator
